import React, { useEffect, useState } from "react";
import { MapPin } from "lucide-react";
import { getConsent, onConsentChange } from "@/lib/consent";

// Google Maps sets cookies: load the iframe only after consent or an explicit click.
export const ConsentMap = ({ src, title, directionsHref }) => {
    const [consented, setConsented] = useState(() => getConsent() === "granted");
    const [revealed, setRevealed] = useState(false);

    useEffect(() => onConsentChange(() => setConsented(getConsent() === "granted")), []);

    if (consented || revealed) {
        return (
            <iframe
                src={src}
                title={title}
                className="w-full h-full"
                loading="lazy"
                allowFullScreen
                referrerPolicy="no-referrer-when-downgrade"
                data-testid="contact-map-iframe"
            />
        );
    }

    return (
        <div className="w-full h-full bg-brand-cream flex flex-col items-center justify-center text-center p-6 gap-4" data-testid="contact-map-placeholder">
            <span className="h-12 w-12 rounded-full bg-brand-mint/40 text-brand-primary inline-flex items-center justify-center">
                <MapPin className="h-5 w-5" />
            </span>
            <p className="font-sans text-sm text-brand-ink/65 max-w-xs">
                La carte est fournie par Google Maps, qui peut déposer des cookies.
            </p>
            <div className="flex flex-wrap justify-center gap-3">
                <button type="button" onClick={() => setRevealed(true)} className="ll-btn ll-btn-primary text-sm !py-2" data-testid="contact-map-show-btn">
                    Afficher la carte
                </button>
                <a href={directionsHref} target="_blank" rel="noreferrer" className="ll-btn ll-btn-ghost text-sm !py-2" data-testid="contact-map-directions-link">
                    Itinéraire
                </a>
            </div>
        </div>
    );
};
